import DB from 'offline/db'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/game/data/expansions.php
export default {
	run: function(filter, data, config, global) {
		if (!global.gameIds || !global.gameIds.length) return
		var rows = DB.query('SELECT game_relation_parent, game_relation_child FROM game_relation WHERE game_relation_parent IN(' + Util.in(global.gameIds) + ')')
		global.expansions = {}
		for (var i = 0; i < rows.length; i++) {
			var r = rows[i]
			if (!global.expansions[r.game_relation_parent]) global.expansions[r.game_relation_parent] = []
			global.expansions[r.game_relation_parent].push(r.game_relation_child)
		}
	}
}
